import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { IPC_CHANNEL, STANDALONE } from '../../_offline/electron.constants';
import { SubjectSchema, SubjectSchemaQueryOpt } from '../../_offline/models/subject.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { SubjectAttributesSchema } from '../../_offline/models/subject-attributes.schema';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class SubjectDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(subjectModelId?: string, enabledOnly = true, isAliveOnly = true): Observable<SubjectSchema[]> {
    const opt = new SubjectSchemaQueryOpt(this.tenantId, subjectModelId, enabledOnly, isAliveOnly);
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT.GET_ALL, opt);
  }

  getAllOnPremise(subjectModelId?: string, enabledOnly = true, isAliveOnly = true): Observable<SubjectSchema[]> {
    const opt = new SubjectSchemaQueryOpt(STANDALONE.TENANT_ID, subjectModelId, enabledOnly, isAliveOnly);
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT.GET_ALL, opt);
  }

  getOne(id: string): Observable<SubjectSchema> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT.GET_ONE, this.tenantId, id);
  }

  putAll(subjects: SubjectSchema[]): Observable<SubjectSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT.PUT_ALL, subjects);
  }

  /**
   * シリアルナンバー(Subject)を追加、更新する。
   *
   * @param subject SubjectSchema。
   * @returns 更新後のシリアルナンバー(Subject)を返す。
   */
  putOne(subject: SubjectSchema): Observable<SubjectSchema> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT.PUT_ONE, subject)
      .pipe(
        map(x => x as SubjectSchema)
      );
  }

  /**
   * 同じシリアル No が存在するかどうかを返す。
   *
   * @param tenantId テナント ID。
   * @param serialNo シリアル No。
   * @param subjectId Subject ID。指定された Subject ID は除外して検索する。空文字の場合は検索条件に含めない。
   * @returns 同じシリアル No が存在する場合は true を返す。
   */
  public isSameSerialNumberExists(tenantId: string, serialNo: string, subjectId: string = ''): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT.IS_SAME_SERIAL_NUMBER_EXISTS, tenantId, serialNo, subjectId)
      .pipe(
        map(x => x as boolean)
      );
  }

  /**
   * Attributesのバージョンを更新してSubjectを返す。
   *
   * @param tenantId テナント ID。
   * @param subjectId Subject ID。指定された Subject を返す。
   * @param beforeAttributes 旧バージョンの Subject Attributes。
   * @param afterAttributes 新バージョンの Subject Attributes。
   * @returns Subject を返す。
   */
  UpdateSubjectAttributesNewestVersion(
    subject: SubjectSchema,
    beforeAttributes: SubjectAttributesSchema,
    afterAttributes: SubjectAttributesSchema,
  ): Observable<SubjectSchema> {
    return this.ipcSendSync(
      IPC_CHANNEL.SUBJECT.UPDATE_SUBJECT_ATTRIBUTES_NEWEST_VERSION,
      this.tenantId,
      subject,
      beforeAttributes,
      afterAttributes
    ).pipe(map((x) => x as SubjectSchema));
  }
}
